import gql from 'graphql-tag';

export const SEND_FEEDBACK = gql`
  mutation sendFeedback($email: String!, $message: String!, $subject: String!) {
    sendFeedback(email: $email, message: $message, subject: $subject) {
      isSucceeded
    }
  }
`;
